import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Lazy load pages for better performance
const LandingPage = lazy(() => import("@/pages/LandingPage"));
const QuizPage = lazy(() => import("@/pages/QuizPage"));
const QuizResumePage = lazy(() => import("@/pages/QuizPage").then(m => ({ default: m.QuizResumePage })));
const ResultsPage = lazy(() => import("@/pages/ResultsPage"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("@/pages/TermsOfService"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));

// Loading fallback
const LoadingFallback = () => (
  <div className="min-h-screen bg-cyber-navy flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-cyber-blue border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="font-orbitron text-cyber-blue text-lg">INITIALIZING...</p>
    </div>
  </div>
);

function App() {
  return (
    <div className="App min-h-screen bg-cyber-navy">
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="/quiz/resume/:resumeToken" element={<QuizResumePage />} />
            <Route path="/results/:quizId" element={<ResultsPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#111827',
            border: '1px solid rgba(0, 212, 255, 0.3)',
            color: '#F9FAFB',
          },
        }}
      />
    </div>
  );
}

export default App;
